module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-right-fill-9bd49a27.svg";